import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchNotificationsByIdRequest = {
	id: number;
};

export const patchNotificationsById = createPatchEndpoint<PatchNotificationsByIdRequest>(
	(request) => `/api/v3/notifications/${request?.id}`,
	{
		requestTransform: (request) => ({
			isRead: true,
			...request
		})
	}
);
